// extracted by mini-css-extract-plugin
module.exports = {"root":"NavLink_root__G3zw9","label":"NavLink_label__eGb0A"};